import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import HeaderTitle from '../../components/HeaderTitle'
import axios from 'axios'
import { useSelector } from 'react-redux'
import swal from 'sweetalert'
import { Helmet } from 'react-helmet'
import ControlPage from '../Auth/ControlPage'
import { isAdmin } from '../../utils/roleUtils'

function buildUserListQuery(page) {
    const params = new URLSearchParams()
    params.set('page', String(Math.max(0, Number(page) || 0)))
    params.append('sort', 'username')
    return params.toString()
}

function Users() {

    const { token, role } = useSelector((state) => state.auth)
    const [users, setUsers] = useState({ content: [] })
    const [inPageIndex, setInPageIndex] = useState(0)

    const getUsers = () => {
        const qs = buildUserListQuery(inPageIndex)
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/user?${qs}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`

                }
            })
            .then((response) => {
                console.log(response.data)
                setUsers(response.data ?? { content: [] })
            })
            .catch((error) => {
                console.error(error)
                setUsers({ content: [], totalPages: 1, totalElements: 0 })
            })
    }

    const deleteUser = (username) => {
        console.log("delete user", username)
        swal({
            title: "Emin misiniz?",
            text: "Bu işlem geri alınamaz!",
            icon: "warning",
            buttons: true,
            dangerMode: true
        }).then((willDelete) => {
            if (willDelete) {
                axios.delete(`${process.env.REACT_APP_SERVICE_URL}/user/${username}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                    .then((response) => {
                        console.log(response.data)
                        getUsers()
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            }
        })
    }

    useEffect(() => {
        getUsers()
    }, [inPageIndex])

    const totalPages = Math.max(1, Number(users?.totalPages) || 1)
    const pageIdx = Math.min(Math.max(0, Number(inPageIndex) || 0), totalPages - 1)
    const pageSize = Number(users?.size) > 0 ? Number(users.size) : 10
    const rowOffset = pageIdx * pageSize

    useEffect(() => {
        const tp = users?.totalPages
        if (typeof tp === 'number' && tp > 0 && inPageIndex >= tp) {
            setInPageIndex(tp - 1)
        }
    }, [users?.totalPages, inPageIndex])

    const goPage = (nextIndex) => {
        const p = Math.min(Math.max(0, nextIndex), totalPages - 1)
        if (p !== (Number(inPageIndex) || 0)) {
            setInPageIndex(p)
        }
    }

    if (!isAdmin(role)) {
        return (
            <ControlPage />
        );
    }

    

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Kullanıcılar</title>
                <meta name='description' content='Sistemde kayıtlı olan kullanıcılar' />
                <meta name='viewport' content='width=device-width, initial-scale=1, shrink-to-fit=no' />
            </Helmet>
            <HeaderTitle title='Kullanıcılar' description='Sistemde kayıtlı olan kullanıcılar' />

            <div className='row'>
                <div className='col-md'>
                    <div className='row mb-3 align-items-center g-2'>
                        <div className='col-12 col-xl'>
                            <div className='d-flex flex-wrap align-items-center gap-2'>
                                <button type="button" title="Yenile" aria-label="Listeyi yenile" className='btn btn-outline-secondary btn-app btn-app--icon' onClick={() => getUsers()}>
                                    <i className='bi bi-arrow-clockwise'></i>
                                </button>
                                <Link to="/users/create" className='btn btn-dark btn-app'>
                                    <i className='bi bi-plus-lg'></i>
                                    Yeni kullanıcı
                                </Link>
                            </div>
                        </div>
                        <div className='col-12 col-xl-auto'>
                            <div className='d-flex flex-wrap align-items-center gap-2 justify-content-xl-end'>
                                <span className='text-muted small text-nowrap me-1'>
                                    {typeof users?.totalElements === 'number' && (
                                        <span className='me-2'>{users.totalElements} kayıt</span>
                                    )}
                                    <span className='fw-medium text-body'>{pageIdx + 1}</span>
                                    <span> / {totalPages}</span>
                                </span>
                                <div className='d-flex align-items-center gap-1' role="group" aria-label="Sayfa seçimi">
                                    <button
                                        type="button"
                                        className='btn btn-outline-secondary btn-app btn-app--icon'
                                        disabled={pageIdx <= 0}
                                        onClick={() => goPage(0)}
                                        title="İlk sayfa"
                                        aria-label="İlk sayfa">
                                        <i className='bi bi-chevron-bar-left'></i>
                                    </button>
                                    <button
                                        type="button"
                                        className='btn btn-outline-secondary btn-app btn-app--icon'
                                        disabled={pageIdx <= 0}
                                        onClick={() => goPage(pageIdx - 1)}
                                        title="Önceki sayfa"
                                        aria-label="Önceki sayfa">
                                        <i className='bi bi-chevron-left'></i>
                                    </button>
                                    <select
                                        className='form-select form-select-app'
                                        aria-label="Sayfa numarası"
                                        value={pageIdx}
                                        onChange={(e) => goPage(Number(e.target.value))}>
                                        {
                                            [...Array(totalPages).keys()].map((p) => (
                                                <option key={p} value={p}>{p + 1}</option>
                                            ))
                                        }
                                    </select>
                                    <button
                                        type="button"
                                        className='btn btn-outline-secondary btn-app btn-app--icon'
                                        disabled={pageIdx >= totalPages - 1}
                                        onClick={() => goPage(pageIdx + 1)}
                                        title="Sonraki sayfa"
                                        aria-label="Sonraki sayfa">
                                        <i className='bi bi-chevron-right'></i>
                                    </button>
                                    <button
                                        type="button"
                                        className='btn btn-outline-secondary btn-app btn-app--icon'
                                        disabled={pageIdx >= totalPages - 1}
                                        onClick={() => goPage(totalPages - 1)}
                                        title="Son sayfa"
                                        aria-label="Son sayfa">
                                        <i className='bi bi-chevron-bar-right'></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='table-responsive'>
                        <table className='table table-striped table-hover'>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Rol</th>
                                    <th>Adı Soyadı</th>
                                    <th>Kullanıcı Adı</th>
                                    <th>Telefon</th>
                                    <th>Şirket</th>
                                    <th>İşlemler</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    users?.content?.map((item, index) => {
                                        return (
                                            <tr key={item.username ?? `user-row-${index}`}>
                                                <td className='align-middle'>{rowOffset + index + 1}</td>
                                                <td className='align-middle'>{item.role}</td>
                                                <td className='align-middle'>{item.firstName + " " + item.lastName}</td>
                                                <td className='align-middle'>{item.username}</td>
                                                <td className='align-middle'>{item.phoneNumber}</td>
                                                <td className='align-middle'>{item.company}</td>
                                                <td>
                                                    <div className='d-inline-flex flex-wrap align-items-center gap-1'>
                                                        <Link to={`/users/reset-password/${item.username}`} className='btn btn-outline-warning btn-app text-dark border-warning'>Şifre</Link>
                                                        <Link to={`/users/edit/${item.username}`} className='btn btn-outline-primary btn-app'>Düzenle</Link>
                                                        <button type="button" onClick={() => deleteUser(item.username)} className='btn btn-outline-danger btn-app'>Sil</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Users